import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Checkbox, FormControl, FormControlLabel, IconButton, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import AddDocumentModal from './AddDocumentModal';
import { archLevel } from 'src/data/config';
import Loader from 'src/components/common/Loader';

const BootstrapDialogTitle = (props: { [x: string]: any; children: any; onClose: any }) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, pl: 3 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

const Ipreleasepage: React.FunctionComponent<any> = ({
  ipReleaseData,
  setIPReleaseData,
  updatedIPReleaseDocs,
  setUpdatedIPReleaseDocs,
  createIPRelease,
  updateIPRelease,
  checkboxVal,
  setCheckboxVal,
  checkboxInputRef,
  setIsIPReleaseSaved,
  isSubmitted,
  IPRTSData,
  IPCodeList,
  isIpReleaseCertified,
  isSignsCompletedLegacy
}) => {
  const { ipRelease } = useFieldTranslation();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { checkPermission } = usePermissionWrapper();
  const perDisable = checkPermission('update_ip_release');
  const siteApp = archLevel === 'site';
  const disableIpRelease = siteApp || isIpReleaseCertified || isSignsCompletedLegacy;

  const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, docID: string) => {
    const targetval = event.target.value;
    const targetValue = typeof targetval === 'string' ? formatInput(targetval) : targetval;
    const targetNa = event.target.name;
    const targetName = typeof targetNa === 'string' ? formatInput(targetNa) : targetNa;
    const updateData: any = [];
    const ids: any = [];
    let uniqueUpdatedReleaseDocs: any = [];
    const changeObject = ipReleaseData.map((ipDoc: any) => {
      if (ipDoc.id === docID) {
        if (updatedIPReleaseDocs.length !== 0) {
          uniqueUpdatedReleaseDocs = updatedIPReleaseDocs.map((existingUpdateDoc: any) => {
            ids.push(existingUpdateDoc.id);
            if (existingUpdateDoc.id === docID) {
              return {
                ...existingUpdateDoc,
                [targetName]: targetValue,
                ip_management_status: ipDoc.ip_management_status,
                ip_management_status_value_code: ipDoc.ip_management_status_value_code
              };
            } else {
              return existingUpdateDoc;
            }
          });
        }
        if (!ids.includes(ipDoc.id)) {
          let mockUpdateIPRel: any = {
            id: ipDoc.id,
            ip_management_comment: '',
            ip_management_status: '',
            ip_management_status_value_code: ipDoc.ip_management_status_value_code
          };
          mockUpdateIPRel = {
            ...mockUpdateIPRel,
            [targetName]: targetValue,
            ip_management_status: ipDoc.ip_management_status,
            ip_management_status_value_code: ipDoc.ip_management_status_value_code
          };
          updateData.push(mockUpdateIPRel);
        }
        return { ...ipDoc, [targetName]: targetValue };
      } else {
        return ipDoc;
      }
    });
    setIPReleaseData(changeObject);
    setUpdatedIPReleaseDocs([...uniqueUpdatedReleaseDocs, ...updateData]);
    setConfirmExitValue(dispatch, true);
    setIsIPReleaseSaved(false);
  };
  const handleSelectionChange = (event: SelectChangeEvent, docID: string) => {
    const targetValue = event.target.value;
    const targetName = event.target.name;
    const updateData: any = [];
    const ids: any = [];
    let uniqueUpdatedReleaseDocs: any = [];
    const changeObject = ipReleaseData.map((ipDoc: any) => {
      if (ipDoc.id === docID) {
        if (updatedIPReleaseDocs.length !== 0) {
          uniqueUpdatedReleaseDocs = updatedIPReleaseDocs.map((existingUpdateDoc: any) => {
            ids.push(existingUpdateDoc.id);
            if (existingUpdateDoc.id === docID) {
              return {
                ...existingUpdateDoc,
                [targetName]: IPCodeList,
                ip_management_comment: ipDoc.ip_management_comment,
                ip_management_status_value_code: targetValue
              };
            } else {
              return existingUpdateDoc;
            }
          });
        }
        if (!ids.includes(ipDoc.id)) {
          let mockUpdateIPRel: any = {
            id: ipDoc.id,
            ip_management_comment: '',
            ip_management_status: '',
            ip_management_status_value_code: ''
          };
          mockUpdateIPRel = {
            ...mockUpdateIPRel,
            [targetName]: IPCodeList,
            ip_management_comment: ipDoc.ip_management_comment,
            ip_management_status_value_code: targetValue
          };
          updateData.push(mockUpdateIPRel);
        }
        return { ...ipDoc, error_msg: false, [targetName]: IPCodeList, ip_management_status_value_code: targetValue };
      } else {
        return ipDoc;
      }
    });
    setIPReleaseData(changeObject);
    setUpdatedIPReleaseDocs([...uniqueUpdatedReleaseDocs, ...updateData]);
    setConfirmExitValue(dispatch, true);
    setIsIPReleaseSaved(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const validateMandatoryFields = () => {
    const validateObjs = ipReleaseData.map((obj: any) => {
      if (obj.ip_management_status_value_code === null || obj.ip_management_status_value_code === '') {
        return { ...obj, error_msg: true };
      } else {
        return obj;
      }
    });
    setIPReleaseData(validateObjs);
    const isErrorReleaseObj = validateObjs.some(
      (obj: any) =>
        obj.error_msg == true ||
        obj.ip_management_status_value_code === null ||
        obj.ip_management_status_value_code === ''
    );
    if (!isErrorReleaseObj) {
      updateIPRelease();
    }
  };

  const handleCheckboxConfirm = (e: any) => {
    setCheckboxVal(e.target.checked);
  };
  return (
    <Grid container>
      <Grid container className="ipformdata">
        <Grid md={12}>
          <p>{ipRelease.header1} </p>
        </Grid>
      </Grid>
      <Grid container spacing={2} mb={2} className="ipformdata heading">
        <Grid item md={4.5}>
          <strong>{ipRelease.label1}</strong>
        </Grid>
        <Grid item md={4.5}>
          <strong>{ipRelease.label2}</strong>
        </Grid>
        <Grid item md={3}>
          <strong>{ipRelease.label3}</strong>
        </Grid>
      </Grid>
      {ipReleaseData &&
        ipReleaseData.map((ipDocument: any) => {
          return (
            <Grid container spacing={2} key={ipDocument.id} className="ipformdata">
              <Grid item md={4.5} mb={1.5} className="artifact-name">
                {ipDocument.ip_management_document}
                {ipDocument.artifact_tooltip !== '' && ipDocument.artifact_tooltip !== null && (
                  <Tooltip title={ipDocument.artifact_tooltip} placement="right">
                    <Button className="grey-btn">
                      <InfoOutlinedIcon />
                    </Button>
                  </Tooltip>
                )}
              </Grid>
              <Grid item md={4.5} mb={1.5}>
                <Tooltip
                  title={ipDocument.ip_management_comment?.length > 32 ? ipDocument.ip_management_comment : null}
                  placement="top"
                >
                  <FormControl fullWidth margin="normal" key={ipDocument.id}>
                    <TextField
                      id="standard-basic"
                      label="Comment"
                      variant="standard"
                      inputProps={{ maxLength: 199 }}
                      name="ip_management_comment"
                      value={ipDocument.ip_management_comment || ''}
                      onChange={e => handleCommentChange(e, ipDocument.id)}
                      disabled={isSubmitted || !perDisable || disableIpRelease}
                    />
                  </FormControl>
                </Tooltip>
              </Grid>
              <Grid item md={3} mb={1.5}>
                <FormControl variant="standard" fullWidth margin="normal" error={ipDocument.error_msg}>
                  <InputLabel id="demo-simple-select-standard-label" required>
                    {ipRelease.label4}
                  </InputLabel>
                  <Select
                    labelId={'demo-simple-select-standard-label'}
                    id="demo-simple-select-standard"
                    label="Select Status"
                    name="ip_management_status"
                    value={ipDocument.ip_management_status_value_code}
                    onChange={e => handleSelectionChange(e, ipDocument.id)}
                    required
                    disabled={isSubmitted || !perDisable || disableIpRelease}
                  >
                    {IPRTSData &&
                      IPRTSData.map((item: any) => {
                        return (
                          <MenuItem key={item.id} value={item.code_list_value_code}>
                            {item.code_list_value}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          );
        })}
      {checkPermission('update_ip_release') ? (
        <Grid container>
          <Grid>
            <Button
              sx={{ mt: 2 }}
              onClick={handleClickOpen}
              disabled={isSubmitted || disableIpRelease}
              startIcon={<AddCircleIcon />}
            >
              {ipRelease.label5}
            </Button>

            <PopupComponent aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
              <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                {ipRelease.label5}
              </BootstrapDialogTitle>
              <DialogContent>
                <Loader />
                <AddDocumentModal
                  open={open}
                  setOpen={setOpen}
                  ipReleaseData={ipReleaseData}
                  createIPRelease={createIPRelease}
                  checkboxVal={checkboxVal}
                  updatedIPReleaseDocs={updatedIPReleaseDocs}
                  validateMandatoryFields={validateMandatoryFields}
                />
              </DialogContent>
            </PopupComponent>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}

      <Grid container>
        <Grid md={12} sx={{ pl: 1, pt: 1 }}>
          <FormControl>
            <FormControlLabel
              disabled={isSubmitted || !perDisable || disableIpRelease}
              control={
                <Checkbox
                  id="agree"
                  checked={checkboxVal}
                  inputRef={checkboxInputRef}
                  onChange={e => handleCheckboxConfirm(e)}
                />
              }
              label={<Typography variant="body2">{ipRelease.label6} </Typography>}
            />
          </FormControl>
        </Grid>
      </Grid>
      {checkPermission('update_ip_release') ? (
        <Grid container className="fixed-buttons-block">
          <Grid md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              <Button
                onClick={() => validateMandatoryFields()}
                disabled={isSubmitted || disableIpRelease}
                variant="text"
              >
                SAVE
              </Button>
            </Stack>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default Ipreleasepage;
